import React, { useState } from 'react';
import './style.scss';
import clsx from 'clsx';
import Button from '../Shared/components/controls/Button';
import {
  Image,
  RichText,
  Text,
  useSitecoreContext,
  Placeholder,
} from '@sitecore-jss/sitecore-jss-react';
import ReCAPTCHA from 'react-google-recaptcha';
import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js'; //https://github.com/dozoisch/react-google-recaptcha
const EligibilityComponent = (props) => {
  //state
  const [enableRecaptcha, setEnableRecaptcha] = useState(false);
  //destructuring
  const { icon, title2, subheading, image, link, heading, text, enableReCAPTCHA } = props?.fields;
  const { params, rendering } = props;

  const context = useSitecoreContext();

  //render
  const shouldRenderLink = link?.value?.href;
  const shouldRenderHeading = heading?.value;
  const shouldRenderIcon = icon?.value?.src;
  const shouldRenderSubHeading = subheading?.value;
  const shouldRenderTitle2 = title2?.value;
  const shouldRenderText = text?.value;
  const shouldRenderImage = image?.value?.src;
  //variables
  const showRecaptcha = !!enableReCAPTCHA?.value;
  const recaptchaKey = context?.sitecoreContext?.siteConfigurations?.googleReCAPTCHAKey ?? '';
  const hasValidRecaptchaKey = typeof recaptchaKey === 'string' && recaptchaKey.trim().length > 0;
  const shouldRenderRecaptcha = showRecaptcha && hasValidRecaptchaKey;

  const rightContentOptionalValue = Array.isArray(
    rendering?.placeholders?.['right-content-optional']
  )
    ? rendering.placeholders['right-content-optional']
    : [];
  const showPlaceholderRightSide = (rightContentOptionalValue?.length ?? 0) > 0;

  const onChange = (value) => {
    if (value === null) {
      //verification expired returns null
      setEnableRecaptcha(false);
    }
    if (value !== '') {
      setEnableRecaptcha(true);
    }
  };
  if (!props?.fields || !props.params)
    return <GenericPlaceholder componentName="EligibilityComponent" />;

  const isEliteTheme = props?.fields?.IsEliteTheme?.value;

  return (
    <div className="content">
      <div
        className={clsx(
          'eligibility-message',
          isEliteTheme ? 'theme-elite' : 'theme-default',
          params?.doNotAddMargins ? 'do-not-add-margins' : 'add-margins',
          params?.Styles
        )}
      >
        <div className="panel left content-left">
          {shouldRenderImage && (
            <div className="image-layer">
              <Image field={image} />
            </div>
          )}

          <div className="wrap-data">
            <div className="wrap flex-it flex-align-item-start flex-justify-start padding-top-200">
              <div className="auto">
                {shouldRenderSubHeading && (
                  <span className="title">
                    <Text field={subheading} />
                  </span>
                )}
                {shouldRenderHeading && <RichText className="description" field={heading} />}
              </div>
            </div>
            {shouldRenderIcon && (
              <div className="head">
                <Image field={icon} className="logo" />
              </div>
            )}
          </div>
        </div>

        <div className="panel right">
          {showPlaceholderRightSide ? (
            <Placeholder name="right-content-optional" rendering={rendering} />
          ) : (
            <div className="wrap flex-it_ flex-align-item-center_ flex-justify-center_ padding-top-200">
              <table className="fullTable">
                <tbody>
                  <tr valign="middle">
                    <td>
                      <div className="auto">
                        {shouldRenderTitle2 && <RichText className="title" field={title2} />}
                        <div className="beforeGetstarted">
                          {shouldRenderText && <RichText className="description" field={text} />}
                        </div>
                        {shouldRenderRecaptcha && (
                          <div className="recaptcha">
                            <ReCAPTCHA sitekey={recaptchaKey} onChange={onChange} />
                          </div>
                        )}
                        {shouldRenderLink && (
                          <Button
                            variant="contained"
                            link={link}
                            disabled={!enableRecaptcha}
                            fullWidth={true}
                          />
                        )}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EligibilityComponent;
